export default "__VITE_ASSET__64LiPOUW__"